module.exports = __webpack_public_path__ + "bm.f5bfc53ab55e58ead9d6.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/bm.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/bm.svg
// module chunks = styles